/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { AaiComponents } from '../../models/AaiComponents';
import { Node } from '../../../core/models/Node';
import { Aai20SchemaDefinition } from './Aai20SchemaDefinition';

/**
 * @author Jakub Senko <jsenko@redhat.com>
 * @author laurent.broudoux@gmail.com
 * @param {Node} parent
 * @class
 * @extends AaiComponents
 */
export class Aai20Components extends AaiComponents {
    public constructor(parent? : any) {
        if(((parent != null && parent instanceof <any>Node) || parent === null)) {
            let __args = arguments;
            super(parent);
        } else if(parent === undefined) {
            let __args = arguments;
            super();
        } else throw new Error('invalid overload');
    }

    /**
     * Creates a schema definition.
     * @param {string} name
     * @return {Aai20SchemaDefinition}
     */
    public createSchemaDefinition(name : string) : Aai20SchemaDefinition {
        return new Aai20SchemaDefinition(this, name);
    }
}
Aai20Components["__class"] = "io.apicurio.datamodels.asyncapi.v2.models.Aai20Components";
Aai20Components["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];




